import React from 'react'

export default function Websection4Box({text}) {
  return (
    <div className='websection4box'>
        <div className="websection4box__item">
           <p>{text}</p> 
        </div>
    </div>
  )
}
